import { Box, Divider, Theme, Typography, styled } from '@mui/material'

export const getTextFontColors = (theme: Theme): { label: string; value: string }[] => [
  { label: 'White', value: theme.palette.common.white },
  { label: 'Light Gray', value: theme.palette.grey[400] },
  { label: 'Gray', value: theme.palette.grey[600] },
  { label: 'Dark Gray', value: theme.palette.grey[800] },
  { label: 'Navy', value: theme.palette.primaryDark.main },
  { label: 'Blue', value: theme.palette.primary.main },
  { label: 'Teal', value: theme.palette.success.main },
  { label: 'Red', value: theme.palette.error.main },
  { label: 'Black', value: theme.palette.common.black },
]

export const FONT_SIZES = [10, 12, 14, 16, 18, 20, 24, 28, 32, 36]

export const PropertiesWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}))

export const FieldSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.75),
}))

export const PropertyLabel = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  color: theme.palette.text.secondary,
  letterSpacing: '0.5',
}))

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
}))

export const SectionHeading = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 700,
  color: theme.palette.text.primary,
  textTransform: 'uppercase',
  letterSpacing: '0.5',
  marginBottom: theme.spacing(-0.5),
}))

export const ColorSwatchRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.75),
}))

export interface IColorSwatchProps {
  swatchColor: string
  isSelected: boolean
}

export const ColorSwatch = styled(Box, {
  shouldForwardProp: prop => prop !== 'swatchColor' && prop !== 'isSelected',
})<IColorSwatchProps>(({ swatchColor, isSelected }) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  backgroundColor: swatchColor,
  cursor: 'pointer',
  border: isSelected ? `2px solid ${swatchColor}` : '2px solid transparent',
  outline: isSelected ? '2px solid #fff' : '2px solid transparent',
  boxShadow: isSelected ? `0 0 0 3px ${swatchColor}` : '0 1px 3px rgba(0,0,0,0.25)',
  transition: 'box-shadow 0.15s ease, outline 0.15s ease',
  '&:hover': {
    boxShadow: `0 0 0 3px ${swatchColor}80`,
  },
}))

export const BoldRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})
